module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADqSURBVEiJ7dQxSsRQEMbxn3Y22wk2olt6AbG1EMHdM8h6B0vBo3gCOxE8wDaeQUU0yx5Di+TBuOTxkthI8A9DmGFmvvBm3mOMzPCGr572iosuAh8Dmid77yKQkvvSWrc9oFEvxiUwV29P4s9tT3E5YsIBTvCJBXaa2ONGzlGL2A+2NgRSbI0bTPGCQ+zjthFNOXstPxp7Zod8jQcch9gpquCf4ypTXxS4xDPOQmyJ3eA/4a4kEIlnuA7+AhP1Ed1ncrIziFSZgi4WNzDLHKsBzSv1Pej8hv0/dkWBVfPtOwvqS1hk5nfDHhnfOUKlkZMveGcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icon_pdf.png
// module id = 96
// module chunks = 0